import Modal from './Components/Modal';

export default Modal;
